import classNames from "classnames";
import React, { useRef, useState } from "react";
import * as Icons from "Components/Icons";

export interface LandingPageFAQItem {
   question: string;
   answer: string;
}

interface LandingPageFAQProps {
   questionsAndAnwsers: LandingPageFAQItem[],
   defaultOpenIndex?: number | null,
}

let instanceCounter = 0;

export const LandingPageFAQ: React.FC<LandingPageFAQProps> = ({ questionsAndAnwsers, defaultOpenIndex = null }) => {
   const [toggledQuestion, setToggledQuestion] = useState<number | null>(defaultOpenIndex);
   const instanceId = useRef(++instanceCounter);
   const toggleQuestion = (index: number) => {
      setToggledQuestion(toggledQuestion == null || toggledQuestion != index ? index : null);
   }
   return (<div className="faq">
      {questionsAndAnwsers.map((qa, index) => {
         const isOpen = index == toggledQuestion;
         const answerId = `page-faq-${instanceId.current}-answer-${index}`;
         const questionId = `page-faq-${instanceId.current}-question-${index}`;
         return (<div key={qa.question} className={classNames("page-faq-item", { "page-faq-item--toggled": isOpen })}>
            <button
               type="button"
               id={questionId}
               className="page-faq-item-content"
               aria-expanded={isOpen}
               aria-controls={answerId}
               onClick={() => toggleQuestion(index)}
            >
               <span className="page-faq-item-toggle">
                  <Icons.Expand />
               </span>
               <span className="page-faq-item-question">
                  {qa.question}
               </span>
            </button>
            <div className="page-faq-item-answer" id={answerId} role="region" aria-labelledby={questionId}>
               {qa.answer}
            </div>
         </div>);
      })}
   </div>);
}